import { CircularProgress } from "@mui/material";

export default function Spinner() {
  return (
    <CircularProgress
      sx={{
        "& .MuiCircularProgress-circle": {
          strokeLinecap: "round",
          stroke: "var(--font-color)",
        },
      }}
      size={50}
    />
  );
}
